import { render, staticRenderFns } from "./EditerGadgetFrameV3.vue?vue&type=template&id=7972cdf9&scoped=true&"
import script from "./EditerGadgetFrameV3.vue?vue&type=script&lang=ts&"
export * from "./EditerGadgetFrameV3.vue?vue&type=script&lang=ts&"
import style0 from "./EditerGadgetFrameV3.vue?vue&type=style&index=0&id=7972cdf9&lang=scss&scoped=true&"
import style1 from "./EditerGadgetFrameV3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7972cdf9",
  null
  
)

export default component.exports